import styled from 'styled-components';
import { ModalButtons, ModalContent } from '~/components/views/common/Modal';
import { paddings } from '~/styled';

export const ChangeLogModalContent = styled(ModalContent)({
  width: 800,
  maxWidth: '100%',
  minHeight: '400px',
  maxHeight: 'calc(100vh - 66px - 35px - 67px)',
  overflowY: 'auto',
});

export const ChangeLogModalButtons = styled(ModalButtons)({
  paddingTop: paddings.defaultPadding,
});
